import React from 'react';

const EyeCloseIcon = ({ width = 22, height = 20, color = '#0A0A0B' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.875 16.825c-.618.117-1.246.175-1.875.175-4.478 0-8.268-2.943-9.543-7A9.97 9.97 0 0 1 3.02 6.971m5.858.908a3 3 0 1 1 4.243 4.243M8.878 7.879l4.243 4.243M8.878 7.879l4.242 4.241m.001.002 3.291 3.29M8.88 7.88 5.59 4.59m0 0L2 1m3.59 3.59A9.953 9.953 0 0 1 11 3c4.478 0 8.268 2.943 9.543 7a10.024 10.024 0 0 1-4.132 5.411M5.59 4.59l10.821 10.821m0 0L20 19"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EyeCloseIcon;
